// biome-ignore lint/style/useFilenamingConvention: TanStack Router dynamic route parameter

import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { hooksQueryOptions } from "@/app/logic-extensions/api/get-hooks";
import { pluginsQueryOptions } from "@/app/logic-extensions/api/get-plugins";
import { LogicExtensionsSkeleton } from "@/app/logic-extensions/components/logic-extensions-skeleton";
import { PluginConfigPage } from "@/app/logic-extensions/pages/plugin-config-page";

export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects/$projectId/contextual-access/$pluginId"
)({
  component: () => (
    <Suspense fallback={<LogicExtensionsSkeleton />}>
      <PluginConfigPage mode="edit" />
    </Suspense>
  ),
  beforeLoad(ctx) {
    ctx.context.queryClient.prefetchQuery(
      pluginsQueryOptions({ binding: "project", scope: ctx.params })
    );
    ctx.context.queryClient.prefetchQuery(
      hooksQueryOptions({ binding: "project", scope: ctx.params })
    );
  },
  loader: ({ params: { pluginId } }) => ({
    pluginId,
    crumb: "Edit System",
  }),
});
